import block from 'bem-cn-lite';
import {FC, useState} from 'react';
import {Button, Checkbox, Modal, Text} from '@gravity-ui/uikit';
import BannerModalBG from '@assets/bannerNY/BannerModalBG.png';
import BannerModalImage from '@assets/bannerNY/BannerModalImage.png';
import BannerModalBGMobile from '@assets/bannerNY/BannerModalBGMobile.png';
import BannerModalImageMobile from '@assets/bannerNY/BannerModalImageMobile.png';
import {useMediaQuery} from 'react-responsive';
import {hideNyBannerForever, markNyBannerShownThisSession} from '@utils';

import './ModalBannerNY.scss';

const b = block('modal-banner-ny');

interface ModalBannerNYProps {
    visibility: boolean;
    stateModal: (value: boolean) => void;
}

export const ModalBannerNY: FC<ModalBannerNYProps> = ({visibility, stateModal}) => {
    const isSmallScreen = useMediaQuery({query: '(max-width: 1150px)'});
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const onCheckboxChange = (e: any, payload?: any) => {
        const next =
            payload?.checked ??
            e?.target?.checked ??
            false;

        setDontShowAgain(Boolean(next));
    };

    const onOk = () => {
        markNyBannerShownThisSession();

        if (dontShowAgain) {
            hideNyBannerForever();
        }

        stateModal(false);
    };

    return (
        <Modal open={visibility} className={b()}>
            <div className={b('container')}>
                <div className={b('image-container')}>
                    <img
                        src={isSmallScreen ? BannerModalBGMobile : BannerModalBG}
                        alt="BG Banner"
                        className={b('bg-image')}
                    />
                    <img
                        src={isSmallScreen ? BannerModalImageMobile : BannerModalImage}
                        className={b('image')}
                        alt="NY Banner"
                    />
                </div>

                <div className={b('content')}>
                    <div className={b('text-container')}>
                        <Text variant={isSmallScreen ? 'header-1' : 'header-2'}>
                            График доставки товаров в праздники
                        </Text>
                        <Text variant="body-2">Уважаемые покупатели!</Text>
                        <Text variant="body-2">
                            Обращаем внимание на график доставки в новогодние праздники:
                        </Text>
                        <ul className={b('list')}>
                            <li>
                                <Text variant="body-2">
                                    заказы с датой поставки{' '}
                                    <Text variant="subheader-2">31 декабря — 6 января</Text> будут
                                    доставлены <Text variant="subheader-2">6 января</Text>
                                </Text>
                            </li>
                            <li>
                                <Text variant="body-2">
                                    заказы с датой поставки{' '}
                                    <Text variant="subheader-2">7 — 12 января</Text> будут
                                    доставлены <Text variant="subheader-2">12 января</Text>
                                </Text>
                            </li>
                        </ul>
                        <div className={b('note')}>
                            <Text variant="body-2">
                                В праздничный период возможны задержки со стороны поставщиков.
                            </Text>
                            <Text variant="body-2">
                                После 12 января доставка работает в обычном режиме.
                            </Text>
                        </div>
                        <Text variant="body-2" className={b('signature')}>
                            С самыми тёплыми пожеланиями, команда Авто-Транзит!
                        </Text>
                    </div>

                    <div className={b('actions')}>
                        <Checkbox size="m" checked={dontShowAgain} onChange={onCheckboxChange}>
                            Больше не показывать
                        </Checkbox>
                        <Button view="action" size="l" onClick={onOk}>
                            Ок, принято
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
